module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/texas-a0d6c9680690aa86d54c0943752e90cd.jpg";